var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11053",
    "data-name": "Group 11053",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3254",
    "data-name": "Rectangle 3254",
    width: 15,
    height: 15,
    fill: "#2e728c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11052",
    "data-name": "Group 11052",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29013",
    "data-name": "Path 29013",
    d: "M14.25,9a.75.75,0,0,0-.75.75v3a.75.75,0,0,1-.75.75H2.25a.75.75,0,0,1-.75-.75v-3a.75.75,0,0,0-1.5,0v3A2.251,2.251,0,0,0,2.25,15h10.5A2.251,2.251,0,0,0,15,12.75v-3A.75.75,0,0,0,14.25,9M6.969,10.281a.672.672,0,0,0,.246.16.715.715,0,0,0,.57,0,.672.672,0,0,0,.246-.16l3-3A.751.751,0,1,0,9.969,6.219L8.25,7.941V.75a.75.75,0,0,0-1.5,0V7.941L5.031,6.219A.751.751,0,0,0,3.969,7.281Z",
    fill: "#2e728c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.ac6558a1c683ef04e2e5836ad139be39.svg";
export { ForwardRef as ReactComponent };